<div class="modal-header">
    <h4 class="modal-title">Select {{ itemType }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <div class="action-toolbar">
                        <div class="search-box" style="width: 100%; margin-bottom: 10px">
                            <fa-icon [icon]="faSearch"></fa-icon>
                            <input
                                class="form-control"
                                type="text"
                                placeholder="Search"
                                (ngModelChange)="modelChangeFn($event)"
                                [(ngModel)]="search"
                                name="search"
                            />
                        </div>
                    </div>
                    <label for="selector">Available {{ itemType }}</label>
                    <wj-list-box
                        #selector
                        class="form-control"
                        style="height: 300px; padding: 0"
                        [itemsSource]="filteredItems"
                        [displayMemberPath]="'name'"
                        [checkedMemberPath]="'checked'"
                    ></wj-list-box>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
